import Vue from 'vue'
import Vuex from 'vuex'
import { getHotGameDetail } from '@/http/api/game'
import { getCookieToken, removeCookieToken, getLoginPolicyVersion } from '@/utils/auth'
import { getUserVipInfo, getUserBasicInfo, getUserAuthInfo } from '@/http/api/user'
import { serverTime, getClientIp, getAuthConfig, getDictConfig, getBoxDlByChannel } from '@/http/api/common'
import utils from '@/utils/index'
import config from '../http/config'
import router from '../router/router'
import { getPayConfig } from '@/http/api/vip'
const hostnames = ['steamstore.cqjsiao.cn', 'steamfbox.bangyoun.cn', 'steamfbox.bangyoup.cn', 'steamfbox.bangyoum.cn', 'steamfbox.bangyoul.cn', 'steamfbox.bangyoua.cn', 'betassteamstore.cqjsiao.cn', 'betassteamfbox.bangyoun.cn', 'betassteamfbox.bangyoup.cn', 'betassteamfbox.bangyoum.cn', 'betassteamfbox.bangyoul.cn', 'betassteamfbox.bangyoua.cn']

const oneLevelId = config.ONE_LEVEL_ID // 一级分类id  可以修改调整的
const USER_AGREEMENT_TowLevelId = config.USER_AGREEMENT_TOW_LEVEL_ID // 用户注册服务协议 二级分类id
const PRIVACY_POLICY_TowLevelId = config.PRIVACY_POLICY_TOW_LEVEL_ID // 用户隐私政策 二级分类id
const PAY_AGREEMENT_TowLevelId = config.PAY_AGREEMENT_TOW_LEVEL_ID // 付费服务协议 二级分类id
const OFF_ACCOUNT_LINK_TowLevelId = config.OFF_ACCOUNT_LINK_TOW_LEVEL_ID // 注销协议 二级分类id
const USER_AGREEMENT = config.WEB_DOMAIN + `/help_center.html?_ts=${+new Date() + 1}&oneLevelId=${oneLevelId}&towLevelId=${USER_AGREEMENT_TowLevelId}` // 用户注册服务协议
const PRIVACY_POLICY = config.WEB_DOMAIN + `/help_center.html?_ts=${+new Date() + 2}&oneLevelId=${oneLevelId}&towLevelId=${PRIVACY_POLICY_TowLevelId}` // 用户隐私政策
const PAY_AGREEMENT = config.WEB_DOMAIN + `/help_center.html?_ts=${+new Date() + 2}&oneLevelId=${oneLevelId}&towLevelId=${PAY_AGREEMENT_TowLevelId}` // 付费服务协议
const OFF_ACCOUNT_LINK = config.WEB_DOMAIN + `/help_center.html?_ts=${+new Date() + 2}&oneLevelId=${oneLevelId}&towLevelId=${OFF_ACCOUNT_LINK_TowLevelId}` // 注销协议
const questionLink = config.WEB_DOMAIN + `/help_center.html?_ts=${+new Date() + 4}&oneLevelId=${oneLevelId}&towLevelId=0` // 常见问题

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        token: getCookieToken(),
        userInfo: {}, // 用户基础信息
        authInfo: {}, // 用户实名认证信息
        authConfig: {}, // 配置的实名信息
        vipInfo: {}, // 用户会员信息
        boxWebsite: config.WEB_DOMAIN + '/steamfbox.html',
        userAgreement: USER_AGREEMENT, // 用户注册服务协议
        privacyPolicy: PRIVACY_POLICY, // 用户隐私政策
        payAgreement: PAY_AGREEMENT, // 付费服务协议
        offAccountLink: OFF_ACCOUNT_LINK, // 注销协议
        originCustomerLink: '', // 原始客服链接
        questionLink: questionLink, // 常见问题
        client_ip: '',
        accountInfo: {},
        clientInfo: {},
        loginPolicyVersion: getLoginPolicyVersion(), // 登录协议版本号
        serverTime: 0, // 服务器时间
        indexDl: '', // 官网下载地址
        landpageDl: '', // 落地页安装包下载地址
        landpageGameName: '', // 落地页游戏名称
        payConfig: {
            wx: true, // 微信支付
            zfb: true
        }, // 支付宝支付
        userGroupInfo: {}, // 用户的开团信息
        messageStatus: {
            ActBenefit: 1,
            ActGroupBuyVip: 0 // 暂时改成0，原来默认值为0
        }
    },
    getters: {
        showBottom() {
            const { hostname, pathname } = window.location
            if (hostnames.indexOf(hostname) > -1 || pathname == '/invite') {
                return false
            } else {
                return true
            }
        },
        // 是否为代运营域名
        isDyyPage() {
            const { hostname } = window.location
            if (hostnames.indexOf(hostname) > -1) {
                return true
            } else {
                return false
            }
        },
        customerLink(state) {
            if (state.userInfo.id) {
                // 如果有用户id，拼接客服链接
                return utils.appendParametersToUrl(state.originCustomerLink, {
                    id: state.userInfo.id
                })
            }
            return state.originCustomerLink
        },
        messageNum(state) {
            return state.messageStatus.ActBenefit + state.messageStatus.ActGroupBuyVip
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token
        },
        setUserBasicInfo(state, info) {
            state.userInfo = { ...state.userInfo, ...info }
        },
        setUserVipInfo(state, info) {
            const tempInfo = { ...info }
            delete tempInfo.is_vip
            // 服务端的is_vip不是最新的，需要我们前端自己计算
            state.vipInfo = { ...state.vipInfo, ...tempInfo }
        },
        setUserVipInfoIsVip(state, is_vip) {
            state.vipInfo = { ...state.vipInfo, is_vip }
        },
        setUserAuthInfo(state, info) {
            state.authInfo = { ...state.authInfo, ...info }
        },
        setAuthConfig(state, info) {
            state.authConfig = { ...state.authConfig, ...info }
        },
        setUserClientIp(state, info) {
            state.client_ip = info
        },
        setDictConfig(state, info) {
            state.originCustomerLink = info
        },
        setLoginPolicyVersion(state, version) {
            state.loginPolicyVersion = version
        },
        setServerTime(state, info) {
            state.serverTime = info
            // 设置会员是否过期
            let is_vip = 0,
                expire_time = state.vipInfo.expire_time,
                leftTime = +new Date(expire_time) / 1000 - info

            if (!expire_time) {
                is_vip = 0
            } else if (leftTime > 0) {
                is_vip = 1
            }
            store.commit('setUserVipInfo', { is_vip })
        },
        setIndexDl(state, info) {
            state.indexDl = info
        },
        setLandpageDl(state, info) {
            state.landpageDl = info
        },
        setLandpageGameName(state, info) {
            state.landpageGameName = info
        },
        setPayConfig(state, info) {
            state.payConfig = { ...state.payConfig, ...info }
        },
        setUserGroupInfo(state, info) {
            state.userGroupInfo = info
        },
        setMessageNum(state, type) {
            if (state.messageStatus[type] > 0) {
                state.messageStatus = {
                    ...state.messageStatus,
                    [type]: 0
                }
            }
        },
        resetState(state) {
            state.token = ''
            state.userInfo = {}
            state.vipInfo = {}
            state.authInfo = {}
            state.authConfig = {}
            state.steamType = 0
            state.steamId = ''
            state.limitFreeTime = ''
            state.accountInfo = {}
            clearInterval(state.checkVipInfoTimeId)
            router.push('/index')
        }
    },
    actions: {
        getLimitFreeTime() {},
        userClientIpAction({ commit }) {
            getClientIp().then((res) => {
                if (res.code == 200) {
                    commit('setUserClientIp', res.data.ip)
                }
            })
        },
        // 用户基础信息
        userBasicInfoAction({ commit }, type) {
            getUserBasicInfo().then((res) => {
                if (res.code != 200) {
                    return
                }

                commit('setUserBasicInfo', res.data)
            })
        },
        // 盒子 会员信息
        userVipInfoAction({ commit }, payload) {
            getUserVipInfo().then((res) => {
                if (res.code === 200) {
                    commit('setUserVipInfo', res.data)
                    if (payload && payload.fn instanceof Function) {
                        console.log('userVipInfoAction=======>', payload)
                        payload.fn()
                    }
                }
            })
        },
        // 实名认证信息
        userAuthInfoAction({ commit }, payload) {
            getUserAuthInfo().then((res) => {
                if (res.code == 200) {
                    commit('setUserAuthInfo', res.data)
                    if (payload && payload.fn instanceof Function) {
                        console.log('userAuthInfoAction=======>', payload)
                        payload.fn(payload.type)
                    }
                }
            })
        },
        authConfigAction({ commit }) {
            getAuthConfig({ code: 'realname' }).then((res) => {
                if (res.code == 200) {
                    commit('setAuthConfig', res.data)
                }
            })
        },
        // 字典、客服地址
        getDictConfigAction({ commit }) {
            getDictConfig({ type: 'STEAMF-BOX-CUSTOMER-SERVICE', page: 1, size: 1 }).then((res) => {
                if (res.code == 200 && Array.isArray(res.data.list)) {
                    let link = res.data.list[0]
                    if (link) {
                        commit('setDictConfig', link.value)
                    }
                }
            })
        },
        // 获取登录协议版本号
        getBoxProtocolVersion({ commit }) {
            getDictConfig({ type: 'BOX_LOGIN_PROTOCOL_VERSION', page: 1, size: 1 }).then((res) => {
                if (res.code == 200 && Array.isArray(res.data.list)) {
                    let item = res.data.list[0]
                    if (item) {
                        commit('setLoginPolicyVersion', item.value)
                    }
                }
            })
        },
        // 获取服务器时间
        getServerTime({ commit }, payload) {
            serverTime().then((res) => {
                if (res.code == 200) {
                    commit('setServerTime', res.data.time)
                    if (payload && payload.fn instanceof Function) {
                        payload.fn(res.data.time)
                    }
                }
            })
        },
        // 用户登出
        userLogOut({ commit }) {
            removeCookieToken()
            commit('resetState')
        },
        // 官网盒子下载地址
        indexPageDlUrl({ commit }) {
            // 优先读取地址的渠道参数，如果没有就读取cookie中的渠道参数
            let storageChannel = Vue.$cookies.get('steamf-gamebox-channel'),
                searchQuery = utils.getUrlParams(),
                query = {},
                channel = searchQuery.channel || storageChannel

            // 渠道 可能是渠道id也可能是渠道名称
            if (channel) {
                if (parseInt(channel).toString() == channel) {
                    query = { channel_id: channel }
                } else {
                    query = { channel: channel }
                }
            } else {
                query = { channel: 'guanwang' }
            }

            getBoxDlByChannel(query).then((res) => {
                if (res.code == 200 && utils.isObject(res.data)) {
                    commit('setIndexDl', res.data.down_url)
                }
            })
        },
        // 获取落地页进来的游戏配置信息
        getHotGameDetail({ commit }) {
            const game_id = Vue.$cookies.get('box_website_game_id'),
                channel = Vue.$cookies.get('steamf-gamebox-channel'),
                query = { game_id, type: 0, channel }
            if (game_id && channel) {
                getHotGameDetail(query).then((res) => {
                    if (res.code == 200 && res.data) {
                        const { list, channel_ok, game_ok } = res.data
                        if (channel_ok == 1 && game_ok == 1) {
                            commit('setLandpageDl', list.download_link)
                            commit('setLandpageGameName', list.game_name)
                        }
                    }
                })
            }
        },
        // 获取支付配置信息
        userPayConfigAction({ commit }) {
            getPayConfig({ orderPrefix: 'ALL' })
                .then((res) => {
                    if (res.code == 200 && utils.isObject(res.data)) {
                        if (Array.isArray(res.data.list) && res.data.list.length) {
                            const wxPay = res.data.list.find((v) => v.is_enable === 1 && v.pay_channel === 'WEIXIN')
                            const zfbPay = res.data.list.find((v) => v.is_enable === 1 && v.pay_channel === 'ALIPAY')
                            commit('setPayConfig', { wx: wxPay })
                            commit('setPayConfig', { zfb: zfbPay })
                        }
                    }
                })
                .catch()
        }
    }
})

export default store
